import React, { createContext, useContext, useState, useEffect } from 'react';
import { useBrand } from './BrandContext';

const ThemeContext = createContext();

export function ThemeProvider({ children }) {
  const brand = useBrand();
  // Saved user preference wins; otherwise the tenant's configured default theme
  // (ThemeProvider mounts inside BrandProvider, so the config is already loaded).
  const [isDark, setIsDark] = useState(() => {
    const saved = localStorage.getItem('marketpulse-theme');
    if (saved) return saved === 'dark';
    return brand.defaultTheme ? brand.defaultTheme === 'dark' : true;
  });

  useEffect(() => {
    document.documentElement.setAttribute('data-theme', isDark ? 'dark' : 'light');
    localStorage.setItem('marketpulse-theme', isDark ? 'dark' : 'light');
  }, [isDark]);

  const toggle = () => setIsDark(prev => !prev);

  return (
    <ThemeContext.Provider value={{ isDark, toggle }}>
      {children}
    </ThemeContext.Provider>
  );
}

export function useTheme() {
  return useContext(ThemeContext);
}
